import { Signal, signal } from "@preact/signals-react";
import { execProgressiveHandler, progressiveHandler } from "../ProgressiveHandler";
import { chainstreamClient } from "../clients/semaphore-api-client";
import { websocketsEvents } from "../websockets";
import { UserCreateRequest, UserReadResponse, UserUpdateRequest } from "websemaphore";
import { current, fbUser, withFirebaseAuth } from "../auth/actions";
import { castArray } from "lodash";
import { cache } from "../app";

export const activityStreamQuery = async (params?: { semaphoreId: string }) => {
    const bq = cache.activityStream;

    const q = params?.semaphoreId ? bq.where("semaphoreId").equals(params.semaphoreId) : bq;

    const res = q
        .toArray()
        .then((res) => {
            return res.sort((a, b) => a.updated < b.updated ? 1 : -1);
        })

    return res;
}
export const cacheActivityStream = async (
    events: string | string[]
) => {
    const ps = castArray(events);

    const msgs = castArray(events)
        .map(_m => typeof _m == 'string' ? JSON.parse(_m) : _m)

    await cache.activityStream.bulkPut(msgs);
};



export const activityStreamSignal = { value: [] } as { value: any[] }; //signal([] as any);
export const statsActivityStreamSignal = signal([] as any);

const processStats = (m: string | string[]) => {
    const msgs = castArray(m).map(_m => JSON.parse(_m));

    cacheActivityStream(msgs);
};

websocketsEvents.on("message", processStats);

// websocketsEvents.on("message", (m: string) => {
//     const msg = JSON.parse(m);
//     activityStreamSignal.value = [msg, ...activityStreamSignal.value]; //.unshift(msg); // 
// });

export const getActivityStream = (params?: { semaphoreId: string }) =>
    progressiveHandler(
        {},
        () => activityStreamQuery(params), //activityStreamSignal,
        async (progress, _cache, params?: {
            after?: string,
            limit?: string
        }) => {
            const res = await chainstreamClient.user.activityStream(progress.page ? { after: progress.page.toString() } : {});
            const d = res.data as any;
            // activityStreamSignal.value = [...d.Items, ...activityStreamSignal.value];
            processStats(d.Items.map((i: any) => JSON.stringify(i)));
            return {
                ...progress,
                page: (d.Items[d.Items.length - 1] || {}).updated || ""
            };
        },
        {
            autostart: true
        }
    );

const createUserSignal = new Signal<UserReadResponse | null>(null);
export const create = () =>
    progressiveHandler(
        {},
        createUserSignal,
        async (progress, _cache, form: UserCreateRequest) => {
            const res = await withFirebaseAuth(() => chainstreamClient.user.create(form));

            const d = res.data as any;
            createUserSignal.value = d;

            return progress;
        },
        {
            autostart: true
        }
    );


const updateUserSignal = new Signal<UserReadResponse | null>(null);
export const update = () =>
    progressiveHandler(
        {},
        updateUserSignal,
        async (progress, _cache, form: UserUpdateRequest) => {
            const res = await chainstreamClient.user.update(form)

            const d = res.data as any;
            updateUserSignal.value = d;

            await execProgressiveHandler(current, {}, { reset: true });


            return progress;
        },
        {
            autostart: true
        }
    );